import { Divider, Drawer, Space, Button, Radio, Slider, Input, Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { apiCall, fetchImage } from "../../../utils/Api";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import Hours from "../../UI/Hours";
import PresetPicker from "../../../globals/styles/PresetPicker";
import ImageSelect from "../../ImageSelect";
import LinkPicker from "../../../globals/styles/LinkPicker";
import BMInput from "../../comps/BMInput";
import { useSession } from "../../../utils/Session";

export default function ContactAndHours(props) {

    const [template,] = useTemplate();
    const [session, setSession] = useSession();
    const [content, setContent] = useState(props.content);
    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [results, setResults] = useState([])
    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {

        container_colour = 0,
        background_image = "",
        background_fit_width = false,
        background_fit_height = false,
        background_tile_image = false,

        background_colour = 0,
        background_width = 700,
        padding_x = 10,
        padding_y = 10,
        address_preset = 0,
        phone_preset = 0,
        hours_heading_preset = 0,
        hours_preset = 0,
        upcoming_heading_preset = 0,
        upcoming_heading = "Upcoming Dates",
        upcoming_preset = 0,
        link_id = 0,
        background_alt = "",
        all_locations = false,
        gap = 10,
    } = data;

    const [contactData, setContactData] = useState();

    const fetchContactAndHours = () => {
        apiCall("webstore/getContactAndHours", {}, (_status, _result) => {
            if (_status) {
                let loc_id = session.store_id;
                if (Array.isArray(_result)) {

                    if (all_locations) {
                        setResults(_result.sort((a, b) => {
                            if (a.location_id === loc_id) return -1;
                            if (b.location_id === loc_id) return 1;
                            return 0;
                        }))
                    } else {
                        let _r = _result.filter(item => item.location_id == loc_id)
                        if (_r.length > 0) {
                            setResults(_r)
                        }
                    }

                }
            }
        }, "customer")
    }

    useEffect(fetchContactAndHours, [all_locations])

    const save = () => {
        close();
        saveItem(id, { ...content })
    }

    const WrapLink = (props) => {
        if (!link_id) { return props.children; }
        return (<a className={"bm-lnk-" + link_id}>{props.children}</a>)
    }

    const drawContact = (contactData = {
        location_id: 0,
        san: "",
        ws_name: "",
        sc_name: "",
        altname: "",
        sc_addr_string: "",
        sc_addr_array: {
            address: "",
            city: "",
            prov: "",
            postal: "",
            country: ""
        },
        sc_email: "",
        sc_phone: "",
        sc_phone_2: "",
        sc_tollfree: "",
        lat_lng: {
            lat: "",
            lng: ""
        },
        ws_htmlhours: "",
        ws_contact_blurb: "",
        chain_number: 0,
        ws_hours: { title: "", weekdays: [], singles: [] }
    }) => {

        const _style = {
            backgroundColor: getColor(background_colour, template, "#202020e6"),
            maxWidth: background_width + "px",
            padding: padding_y + "px " + padding_x + "px",
            margin: "0 auto",
            textAlign: "center",

        }
        let _default_address_style = {
            color: "#fff"
        }
        let _default_phone_style = {
            color: "#069"
        }
        return (
            <div>
                <div style={_style}>
                    <div className="shim" style={{ "height": "20px" }} />
                    <h3 className={"bm-txt-" + address_preset} style={(address_preset ? {} : _default_address_style)} >
                        {(contactData.sc_name && <div>{contactData.sc_name}</div>)}
                        {(contactData.sc_addr_array.address && <div>{contactData.sc_addr_array.address}</div>)}
                        {((contactData.sc_addr_array.city) && <div>{contactData.sc_addr_array.city}, {contactData.sc_addr_array.prov} {contactData.sc_addr_array.postal}</div>)}
                        {(contactData.sc_addr_array.country && <div>{contactData.sc_addr_array.country}</div>)}
                    </h3>
                    <div className="shim" style={{ "height": "20px" }} />
                    <h3 className={"bm-txt-" + phone_preset} style={(phone_preset ? {} : _default_phone_style)}>
                        {(contactData.sc_phone && <div><WrapLink>{contactData.sc_phone}</WrapLink></div>)}
                        {(contactData.sc_phone_2 && <div><WrapLink>{contactData.sc_phone_2}</WrapLink></div>)}
                        {(contactData.sc_tollfree && <div><WrapLink>toll free {contactData.sc_tollfree}</WrapLink></div>)}
                        {(contactData.sc_email && <div><WrapLink>{contactData.sc_email}</WrapLink></div>)}
                    </h3>
                    <div className="shim" style={{ "height": "20px" }} />
                    <Hours ws_hours={contactData.ws_hours} template={template} data={data} />
                    <div className="shim" style={{ "height": "20px" }} />
                </div>
            </div>
        )
    }

    const drawRender = () => {

        let _sizeY = (background_fit_height) ? "100%" : "auto";
        let _sizeX = (background_fit_width) ? "100%" : "auto";

        const _bg_style = {
            backgroundPosition: "top",
            backgroundColor: getColor(container_colour, template, "#fff"),
            backgroundImage: `url('${fetchImage(background_image)}')`,
            backgroundRepeat: (background_tile_image) ? "repeat" : "no-repeat",
            backgroundSize: `${_sizeX} ${_sizeY}`,
            display: "flex",
            flexDirection: "column",
            gap: gap,
        }


        return (
            <div role="img" aria-label={(background_image) ? background_alt : ""} style={_bg_style}>
                {results.map(item => {
                    return (
                        <div >
                            {drawContact(item)}
                        </div>
                    )
                })}
            </div>
        )

    }

    const drawForm = () => {
        return (
            <>
                <div style={{ "fontSize": "18px", "lineHeight": "18px" }}><strong>{name}</strong></div>
                {(date_changed && <em style={{ "fontSize": "12px" }}>Last updated {moment(date_changed * 1000).format("MMM Do, YYYY h:mm a")}</em>)}
                <div className="shim" /><div className="shim" />
                <div style={{ "display": "flex", "justifyContent": "stretch" }}>
                    <Button onClick={() => save()} block size="small" type="primary"><small>Save Changes</small></Button>
                    <div style={{ "width": "10px" }}></div>
                    <Space>
                        <Button onClick={() => close()} size="small" type="default"><small>Cancel</small></Button>
                    </Space>
                </div>
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                {/* CONTAINER */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LAYOUT</Divider>
                <div className="float-flex">
                    <div></div>
                    <Space>
                        <Radio.Group value={container} onChange={(e) => setContent({ ...content, "container": e.target.value })} >
                            <Radio value={false}><small>100% of the screen width</small></Radio>
                            <Radio value={true}><small>Container width (max 1248px)</small></Radio>
                        </Radio.Group>
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />

                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_none allow_gradient value={container_colour} onChange={(e) => setData({ ...data, "container_colour": e })} />
                <div className="shim" /> <div className="shim" />

                {/* BACKGROUND IMAGE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND IMAGE</Divider>
                <ImageSelect require_alt alt={background_alt} onChange={(_v, _alt) => setData({ ...data, "background_image": _v, "background_alt": _alt })} width={235} path={background_image} />
                <div className="shim" /><div className="shim" />

                {/* BACKGROUND ALT */}
                <div className="shim" />
                <BMInput allow_update value={background_alt} onChange={(e) => setData({ ...data, "background_alt": e })} prefix_width={"50px"} prefix={<nobr>ALT TEXT &nbsp;</nobr>} width={"190px"} placeholder={"Describe the image..."} />
                <div className="shim" /><div className="shim" />


                {/* BG IMAGE PROPERTIES */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">FIT</Divider>
                <Space>
                    <Checkbox checked={background_fit_width} onChange={(e) => setData({ ...data, "background_fit_width": e.target.checked })} ><small>Fit Width?</small></Checkbox>
                    <Checkbox checked={background_fit_height} onChange={(e) => setData({ ...data, "background_fit_height": e.target.checked })} ><small>Fit Height?</small></Checkbox>
                    <Checkbox checked={background_tile_image} onChange={(e) => setData({ ...data, "background_tile_image": e.target.checked })} ><small>Tile?</small></Checkbox>
                </Space>
                <div className="shim" /> <div className="shim" />

                {((Array.isArray(window.sitesettings.stores) && window.sitesettings.stores.length > 1) &&
                    <div>
                        <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                        <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SHOW ALL LOCATIONS / GAP</Divider>
                        <div className="float-flex">
                            <div>
                                <div className="shim" />
                                <Checkbox checked={all_locations} onChange={(e) => setData({ ...data, "all_locations": e.target.checked })} ><small>Show All?</small></Checkbox>
                            </div>
                            <Slider
                                style={{ "width": "130px" }}
                                min={0}
                                max={100}
                                onChange={(_v) => setData({ ...data, "gap": _v })}
                                value={gap}
                            />
                        </div>
                    </div>
                )}


                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>

                {/* BACKGROUND WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HOURS BACKGROUND WIDTH</Divider>
                <Slider
                    style={{ "width": "150px" }}
                    min={400}
                    max={1248}
                    onChange={(_v) => setData({ ...data, "background_width": _v })}
                    value={background_width}
                />
                <div className="shim" /> <div className="shim" />
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HOURS BACKGROUND COLOUR</Divider>
                <ColourPicker allow_none allow_gradient value={background_colour} onChange={(e) => setData({ ...data, "background_colour": e })} />
                <div className="shim" /> <div className="shim" />
                {/* ADDRESS PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ADDRESS PRESET</Divider>
                <PresetPicker value={address_preset} onChange={(e) => setData({ ...data, "address_preset": e })} />
                <div className="shim" /> <div className="shim" />
                {/* PHONE PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PHONE PRESET</Divider>
                <PresetPicker value={phone_preset} onChange={(e) => setData({ ...data, "phone_preset": e })} />
                <div className="shim" /> <div className="shim" />
                {/* HOURS PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HOURS HEADING PRESET</Divider>
                <PresetPicker value={hours_heading_preset} onChange={(e) => setData({ ...data, "hours_heading_preset": e })} />
                <div className="shim" /> <div className="shim" />
                {/* HOURS PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HOURS PRESET</Divider>
                <PresetPicker value={hours_preset} onChange={(e) => setData({ ...data, "hours_preset": e })} />
                <div className="shim" /> <div className="shim" />
                {/* UPCOMING HEADING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">UPCOMING HEADING</Divider>
                <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "upcoming_heading": e.target.value })} value={upcoming_heading} placeholder="Heading..." />
                <div className="shim" /> <div className="shim" />
                {/* UPCOMING HEADING PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">UPCOMING HEADING PRESET</Divider>
                <PresetPicker value={upcoming_heading_preset} onChange={(e) => setData({ ...data, "upcoming_heading_preset": e })} />
                <div className="shim" /> <div className="shim" />
                {/* UPCOMING PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">UPCOMING PRESET</Divider>
                <PresetPicker value={upcoming_preset} onChange={(e) => setData({ ...data, "upcoming_preset": e })} />
                <div className="shim" /> <div className="shim" />

                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK STYLE</Divider>
                <LinkPicker nostyle={true} value={link_id} onChange={(e) => setData({ ...data, "link_id": e })} />
                <div className="shim" /> <div className="shim" />

            </>
        )
    }
    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}